module.exports = __webpack_public_path__ + "static/img/angry_green.71233d26.png";